import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { PartnerProvider } from "../../context/PartnerContext";

export const Partner = () => {
  return (
    <PartnerProvider>
      <Overview />
    </PartnerProvider>
  );
};

export const AddPartner = () => {
  return (
    <PartnerProvider>
      <Add />
    </PartnerProvider>
  );
};

export const EditPartner = () => {
  return (
    <PartnerProvider>
      <Edit />
    </PartnerProvider>
  );
};
